<template>
  <span class="gs-affiliate-pills" aria-label="Selected affiliates">
    <span v-for="affiliate in visibleAffiliates" :key="affiliate.id" class="gs-affiliate-pills__name" :title="affiliate.name">
      {{ affiliate.name || `Affiliate #${affiliate.id}` }}
    </span>
    <button v-if="expandable && affiliates.length > limit" type="button" class="gs-affiliate-pills__more" :aria-expanded="expanded ? 'true' : 'false'" @click.stop="expanded = !expanded">{{ expanded ? 'Show fewer' : `Plus ${remaining} more` }}</button>
    <span v-else-if="remaining" class="gs-affiliate-pills__more">+{{ remaining }} more</span>
  </span>
</template>
<script>
export default {
  props: { affiliates: { type: Array, default: () => [] }, limit: { type: Number, default: 5 }, expandable: { type: Boolean, default: false } },
  data: () => ({ expanded: false }),
  computed: {
    visibleAffiliates() { return this.expanded ? this.affiliates : this.affiliates.slice(0, this.affiliates.length > this.limit ? this.limit - 1 : this.limit); },
    remaining() { return this.affiliates.length - this.visibleAffiliates.length; },
  },
};
</script>
<style scoped>
.gs-affiliate-pills { display:flex; flex-wrap:wrap; gap:6px; min-width:0; }
.gs-affiliate-pills__name, .gs-affiliate-pills__more { display:inline-block; max-width:100%; padding:4px 10px; border:1px solid var(--gs-active-border); border-radius:999px; background:var(--gs-active-soft); color:var(--gs-active); font-size:12px; font-weight:600; line-height:1.5; overflow-wrap:anywhere; }
.gs-affiliate-pills__more { border-color:var(--gs-border); color:var(--gs-muted-foreground); background:var(--gs-muted); }
button.gs-affiliate-pills__more { cursor:pointer; font-family:inherit; }
button.gs-affiliate-pills__more:focus-visible { outline:2px solid var(--gs-active); outline-offset:2px; }
</style>
